/**
 * Beneficial Owner Notices (M32108) mapper.
 * 공유 values + signers → Word [[변수]] payload.
 */
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import {
  emptyBoNoticeSurvey,
  type BoNoticeSurvey,
} from '../components/boNotices/boNoticeSurvey';

export interface BoNoticeState {
  values: Record<string, string>;
  /** 문서별 [[Signers]] — 전부 동일 varKey('notice') 공유 가능 */
  signers: Record<string, SignerEntry[]>;
  /** Stage 진입 전 설문 — 포함 문서 결정 */
  survey: BoNoticeSurvey;
}

export function emptyBoNoticeState(): BoNoticeState {
  return {
    values: {},
    signers: {},
    survey: emptyBoNoticeSurvey(),
  };
}

export function buildBoNoticeVariables(state: BoNoticeState): Record<string, any> {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(state.values || {})) {
    out[k] = v ?? '';
  }
  return out;
}
